import { DefaultStatistic, Statistic } from 'Shared/molecules/Statistic/types'

// data should be in correct order
export const mergeStatistic = <T extends {}>(statistic: T, data: DefaultStatistic[]) => {
	const values = Object.values(statistic) as number[]
	return data.reduce((acc, stat, index) => {
		acc.push({
			...stat,
			value: values[index].toString()
		})
		return acc
	}, [] as Statistic[])
}
